<template>
  <div class="spinner">
    <div class="spinner__circle"></div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
 @import "@/assets/scss/app";

.spinner {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: $black;
  z-index: 999;

  .spinner__circle {
    border: 16px solid $green;
    border-top: 16px solid $darkgreen-1;

    
    /* Blue */
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: spin 2s linear infinite;
    margin: auto;
    top: 50%;
    position: relative;
  }

}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
  
}
</style>